module.exports = __webpack_public_path__ + "img/product_100.24b9796.webp";